export default "__VITE_ASSET__af007f59__"